import React, { useCallback, useEffect, useState } from "react";
import { Table, Image, Select, Input } from "antd";
import AddFeedModal from "../../../Components/AddFeedModal";
import { CreateButton } from "../category/Categories";
import { toast } from "react-toastify";
import styled from "styled-components";
import { DeleteIcon, EditIcon, PinIcon } from "../../../Utils/SvgIcons";
import { fixCapcutLink } from "../../../Utils/capcutLinkFixer";
import DeleteModal from "../../../Components/modals/DeleteConfirm";
import { debounce, deleteFileFromR2 } from "../../../Utils/commonFunction";
import { apiDelete, apiGet, apiPut } from "../../../Utils/api";
import PinCategoryModal from "./PinCategoryModal";
const { Option } = Select;

const Dashboard = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [pinModal, setPinModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  const columns = [
    {
      title: "S.No.",
      key: "index",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1 + ".",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Image",
      dataIndex: "imageUrl",
      key: "imageUrl",
      render: (text) => <Image width={50} src={text} alt="Image" />,
    },
    {
      title: "Video URL",
      dataIndex: "videoUrl",
      key: "videoUrl",
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          View Video
        </a>
      ),
    },
    {
      title: "Capcut Link",
      dataIndex: "capcut_link",
      key: "capcut_link",
      render: (text) => (
        <p
          style={{
            color: "#5ea1ff",
            maxWidth: "100px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </p>
      ),
    },
    {
      title: "Whatsapp Link",
      dataIndex: "whatsapp_link",
      key: "whatsapp_link",
      render: (text) => (
        <p
          style={{
            color: "#5ea1ff",
            maxWidth: "100px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </p>
      ),
    },
    {
      title: "Telegram Link",
      dataIndex: "telegram_link",
      key: "telegram_link",
      render: (text) => (
        <p
          style={{
            color: "#5ea1ff",
            maxWidth: "100px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </p>
      ),
    },
    {
      title: "Categories",
      dataIndex: "categories",
      key: "categories",
      render: (categories) => (categories || [])?.join(", "),
    },
    {
      title: "Actions",
      key: "actions",

      render: (_, record) => (
        <ActionBox>
          <button
            style={{ backgroundColor: "#5ea1ff" }}
            className="edit"
            onClick={() => {
              setPinModal(true);
              setSelectedFeed(record);
            }}
          >
            <PinIcon />
          </button>
          <button
            className="edit"
            onClick={() => {
              setSelectedFeed(record);
              setAddFeedModal(true);

              // openEditModal(record);
            }}
          >
            <EditIcon />
          </button>

          <button
            className="delete"
            onClick={() => {
              setSelectedFeed(record);
              setDeleteModalVisible(true);
              // handleDeleteFeed(record.id);
            }}
          >
            <DeleteIcon />
          </button>
        </ActionBox>
      ),
    },
  ];
  const [addFeedModal, setAddFeedModal] = useState(false);
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryOptions, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [fixingLinks, setFixingLinks] = useState(false);
  const image_url = process.env.REACT_APP_IMAGE_BASEURL;

  console.log(selectedFeed, "selectedFeed");

  const fetchFeeds = async (filters = [], search = "", page = 1) => {
    setLoading(true);
    try {
      // The API accepts a single `category` filter; when several are
      // selected we send the first one and filter the rest client-side.
      const params = new URLSearchParams({
        page: String(page),
        limit: String(pageSize),
      });
      if (filters?.length) params.set("category", filters[0]);
      if (search) params.set("search", search);

      const data = await apiGet(`/api/feeds?${params.toString()}`);

      let feedsList = (data?.feeds || []).map((feed) => ({
        key: feed.id,
        id: feed.id,
        name: feed.name,
        categories: feed.categories_name,
        imageUrl: feed.thumbnail,
        videoUrl: feed.video,
        capcut_link: feed.capcut_link,
        pinnedCategories: feed.pinned_categories || [],
        telegram_link: feed.telegram_link,
        whatsapp_link: feed.whatsapp_link,
        createdAt: feed.created_at,
      }));

      // Client-side filter for any additional selected categories
      if (filters?.length > 1) {
        feedsList = feedsList.filter((feed) =>
          filters.every((cat) => (feed.categories || []).includes(cat))
        );
      }

      setTotalCount(data?.total || 0);
      setFeeds(feedsList);
    } catch (error) {
      console.error("Error fetching feeds:", error);
    } finally {
      setLoading(false);
    }
  };

  const UpdatedAfterAdd = () => {
    setCurrentPage(1);
    fetchFeeds(selectedCategories, searchQuery, 1);
  };

  const handleFilterChange = (values) => {
    console.log(values, "values");
    setSelectedCategories(values);
    setCurrentPage(1);
    fetchFeeds(values, searchQuery, 1); // ✅ Correct order: filters, search, page
  };

  const handleTableChange = useCallback(
    (pagination) => {
      const { current } = pagination;
      setCurrentPage(current);
      fetchFeeds(selectedCategories, searchQuery, current);
    },
    [selectedCategories, searchQuery]
  );

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearchQuery(value);
      setCurrentPage(1);
      fetchFeeds(selectedCategories, value, 1);
    }, 500),
    [selectedCategories]
  );

  const fixAllCapcutLinks = async () => {
    setFixingLinks(true);
    try {
      let updated = 0;

      // Walk every page of feeds and fix links via the API
      let page = 1;
      let hasMore = true;
      while (hasMore) {
        const data = await apiGet(`/api/feeds?page=${page}&limit=100`);
        const pageFeeds = data?.feeds || [];
        const updates = pageFeeds.map(async (feed) => {
          const original = feed.capcut_link || "";
          const fixed = fixCapcutLink(original, window.location.origin);
          if (fixed && fixed !== original) {
            await apiPut(`/api/feeds/${feed.id}`, { capcut_link: fixed });
            updated++;
          }
        });
        await Promise.all(updates);
        hasMore = Boolean(data?.hasMore);
        page++;
      }

      toast.success(`${updated} feed link(s) fixed successfully!`);
      fetchFeeds(selectedCategories, searchQuery, currentPage);
    } catch (error) {
      console.error("Error fixing CapCut links:", error);
      toast.error("Failed to fix CapCut links. Please try again.");
    } finally {
      setFixingLinks(false);
    }
  };

  const handleDeleteFeed = async () => {
    // try {
    setDeleteLoading(true);
    if (selectedFeed?.imageUrl?.includes(image_url)) {
      const bucketPath = selectedFeed?.imageUrl?.split(image_url)[1];
      await deleteFileFromR2(bucketPath);
    }
    if (selectedFeed?.videoUrl?.includes(image_url)) {
      const bucketPath = selectedFeed?.videoUrl?.split(image_url)[1];
      await deleteFileFromR2(bucketPath);
    }
    await apiDelete(`/api/feeds/${selectedFeed?.id}`);

    toast.success("Feed deleted successfully!");
    fetchFeeds(selectedCategories, searchQuery, currentPage);
    setDeleteModalVisible(false);
    setDeleteLoading(false);
    // } catch (error) {
    //   console.error("Error deleting Feed:", error);
    //   toast.error("Failed to delete Feed.");
    // } finally {
    //   setDeleteLoading(false);
    // }
  };

  const fetchCategories = async () => {
    setCategoryLoading(true);
    try {
      const data = await apiGet("/api/categories");
      const categoryList = (data?.categories || []).map((cat, index) => ({
        key: cat.id,
        id: cat.id,
        sNo: index + 1,
        name: cat.name,
        value: cat.name,
      }));
      setCategories(categoryList);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error fetching categories");
    } finally {
      setCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchFeeds(selectedCategories, searchQuery, currentPage);
  }, []);

  return (
    <div style={{ marginTop: 20 }}>
      {addFeedModal && (
        <AddFeedModal
          isVisible={addFeedModal}
          onClose={() => setAddFeedModal(false)}
          fetchFeeds={UpdatedAfterAdd}
          feedToEdit={selectedFeed}
          setPage={setCurrentPage}
        />
      )}
      {pinModal && (
        <PinCategoryModal
          visible={pinModal}
          onClose={() => setPinModal(false)}
          assignedCategories={selectedFeed}
          handleList={UpdatedAfterAdd}
          feedId={selectedFeed?.id}
          pinnedCategories={selectedFeed?.pinnedCategories}
        />
      )}
      {deleteModalVisible && (
        <DeleteModal
          visible={deleteModalVisible}
          onConfirm={handleDeleteFeed}
          onCancel={() => setDeleteModalVisible(false)}
          loading={deleteLoading}
          itemName="this feed"
        />
      )}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 style={{ textAlign: "start", fontFamily: "Poppins" }}>Feeds</h2>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Select
            mode="multiple"
            allowClear
            loading={categoryLoading}
            placeholder="Filter by Categories"
            style={{
              width: selectedCategories?.length > 1 ? 320 : 200,
            }}
            maxTagCount={2}
            value={selectedCategories}
            prefixCls="filter"
            onChange={handleFilterChange}
          >
            {categoryOptions.map((category, idx) => (
              <Option key={idx} value={category?.name}>
                {category?.name}
              </Option>
            ))}
          </Select>
          <Input
            placeholder="Search by name"
            allowClear
            onChange={(e) => debouncedSearch(e.target.value)}
            style={{ width: 200 }}
          />
          <CreateButton
            onClick={() => {
              setSelectedFeed(null);
              setAddFeedModal(true);
            }}
          >
            + Create
          </CreateButton>
          <CreateButton
            onClick={fixAllCapcutLinks}
            disabled={fixingLinks}
            style={{ backgroundColor: "#5ea1ff" }}
          >
            {fixingLinks ? "Fixing..." : "Fix CapCut Links"}
          </CreateButton>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={feeds}
        loading={loading}
        scroll={{ x: "auto" }}
        pagination={{
          current: currentPage,
          pageSize,
          total: totalCount,
          showSizeChanger: false,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Dashboard;

const ActionBox = styled.div`
  display: flex;
  gap: 10px;

  .edit {
    background: #28a3a9;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-style: none;
  }
  .delete {
    background: #fb4a49;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-style: none;
  }
`;
